/** Invite tokens arrive as `/join/<token>` (the API's link shape) or `?invite=<token>`; they live in memory only. */

const TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/;

export function readInviteToken(url: URL): string | null {
  const joined = /^\/join\/([^/?#]+)\/?$/.exec(url.pathname);
  const candidate = joined?.[1] ?? url.searchParams.get("invite");
  return candidate && TOKEN_PATTERN.test(candidate) ? candidate : null;
}

export function readJoinedProject(url: URL): string | null {
  const projectId = url.searchParams.get("project");
  return projectId && /^[0-9a-f-]{36}$/i.test(projectId) ? projectId : null;
}

export function inviteUrl(origin: string, token: string): string {
  return `${origin.replace(/[/]$/, "")}/join/${token}`;
}
